// extracted by mini-css-extract-plugin
export default {"icon":"icon___d3f354bd312399ba4fea","tooltip":"tooltip___c7988531166ebcca378d"};